export type AlertMessage = {
  content: string,
  viewed: boolean,
  displayClass?: ?string
}

const buildAlertMessage = (content: string, displayClass: ?string = null): AlertMessage => {
  return {
    content,
    displayClass: displayClass,
    viewed: false
  }
}

export {
  buildAlertMessage
}



// WEBPACK FOOTER //
// ./src/types/alert-message.js